import { I as t } from "../../constants-DeVuDy8J.js";
import { createElementBlock as r, openBlock as d, normalizeClass as n, createElementVNode as l } from "vue";
import { _ as o } from "../../_plugin-vue_export-helper-CHgC5LLL.js";
const s = {
  name: "DtIconBellMinus",
  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: String,
      default: "500",
      validator: (a) => Object.keys(t).includes(a)
    },
    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: void 0
    }
  },
  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ["loaded"],
  computed: {
    iconSizeClass() {
      return t[this.size];
    },
    ariaHidden() {
      return this.ariaLabel ? "false" : "true";
    },
    dataQA() {
      return this.$attrs["data-qa"] ?? "dt-icon";
    }
  },
  created() {
    this.$emit("loaded");
  }
}, c = ["aria-label", "data-qa", "aria-hidden"], u = /* @__PURE__ */ l("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M4.884 10.068a.5.5 0 0 1 .683.181.5.5 0 0 0 .865 0 .5.5 0 0 1 .865.502 1.5 1.5 0 0 1-2.595 0 .5.5 0 0 1 .182-.683ZM7 2.5a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1-.5-.5Z",
  "clip-rule": "evenodd"
}, null, -1), _ = /* @__PURE__ */ l("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M6.417 1.535A2.5 2.5 0 0 0 3.5 4c0 1.824-.391 3.033-.811 3.802-.038.07-.076.136-.114.198h6.85a4.58 4.58 0 0 1-.052-.088c-.4-.69-.792-1.769-.862-3.39a.5.5 0 0 1 .999-.044c.064 1.476.417 2.396.728 2.932.157.27.305.447.407.552a1.43 1.43 0 0 0 .137.125m.001.001A.5.5 0 0 1 10.5 9h-9a.5.5 0 0 1-.277-.916L1.5 8.5l-.277-.416H1.22v.002h-.003a1.513 1.513 0 0 0 .153-.142c.113-.117.274-.317.44-.62.33-.607.689-1.648.689-3.324A3.5 3.5 0 0 1 6.583.549a.5.5 0 1 1-.166.986",
  "clip-rule": "evenodd"
}, null, -1), h = [
  u,
  _
];
function m(a, f, i, p, v, e) {
  return d(), r("svg", {
    "aria-label": i.ariaLabel,
    class: n([e.iconSizeClass, "d-icon d-icon--bell-minus"]),
    "data-qa": e.dataQA,
    "aria-hidden": e.ariaHidden,
    role: "img",
    "data-name": "Bell Minus",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 12 12"
  }, h, 10, c);
}
const I = /* @__PURE__ */ o(s, [["render", m]]);
export {
  I as default
};
//# sourceMappingURL=bell-minus.js.map
